angular.module('impactx.company').controller('SupplierConnectionCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    'BackService',
    'ToastService',
    '$mdDialog',
    'themeFactory',
    SupplierConnectionCtrl
]);

function SupplierConnectionCtrl($scope, dataGen, TranslationService, BackService, ToastService, $mdDialog, themeFactory) {
    var self = this;
    $scope.theme = themeFactory.getTheme();

    dataGen.getData($scope, {comId: self.companyId}, "/company/supplierconnection/view").then(function () {
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.abort = TranslationService.get('abort');
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
    });

    self.save = function() {
        return dataGen.postAsForm({}, {data: $scope.data}, "/company/supplierconnection/save").then(function() {
            $mdDialog.hide();
        });
    }

    self.cancel = function () {
        $mdDialog.cancel();
    }

    self.clearSelectedCompany = function () {
        $scope.data.connectedSupplier.selected = undefined;
    };
}